import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
const RELEASES = [{
  title: 'Button Up',
  type: 'Single',
  year: '2026',
  image: 'https://cdn.magicpatterns.com/uploads/jU2s3LMGnJw1mpbAA8teWX/Untitled_design-23.png',
  url: 'https://ruslansilvr.ffm.to/buttonup'
}, {
  title: 'Fighting the Pitcher',
  type: 'Album',
  year: '2024',
  image: 'https://cdn.magicpatterns.com/uploads/3ijMaAxhSAShvoBNDc2hfR/3.png',
  url: 'https://ruslansilvr.ffm.to/ftp'
}, {
  title: 'Daydream',
  type: 'Single',
  year: '2024',
  image: 'https://cdn.magicpatterns.com/uploads/jU3ruGHHTmwwmTWV8GxKmk/newer_one.png',
  url: 'https://ruslansilvr.ffm.to/daydream'
}, {
  title: 'juk',
  type: 'Single',
  year: '2023',
  image: 'https://cdn.magicpatterns.com/uploads/5eNvLoXK6UW66JNDiZSYPq/Untitled_design-14.png',
  url: 'https://ruslansilvr.ffm.to/juk'
}];
export function Music() {
  const trackRef = useRef<HTMLDivElement>(null);
  const scrollByCard = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const firstCard = track.querySelector<HTMLElement>('[data-card]');
    const amount = firstCard ? firstCard.offsetWidth + 32 : track.clientWidth * 0.8;
    track.scrollBy({
      left: amount * direction,
      behavior: 'smooth'
    });
  };
  return <section id="music" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-50">
      <div className="flex items-end justify-between gap-6" data-id="element-51">
        <div className="flex-1" data-id="element-52">
          <SectionHeader number="02" title="Music" data-id="element-53" />
        </div>
        <div className="hidden md:flex items-center gap-3 mb-12 md:mb-20" data-id="element-54">
          <button type="button" onClick={() => scrollByCard(-1)} aria-label="Previous releases" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black" data-id="element-55">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-56" />
          </button>
          <button type="button" onClick={() => scrollByCard(1)} aria-label="Next releases" className="w-12 h-12 rounded-full border border-brand-white/20 flex items-center justify-center text-brand-white hover:bg-brand-accent hover:border-brand-accent transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black" data-id="element-57">
            <ChevronRightIcon className="w-5 h-5" data-id="element-58" />
          </button>
        </div>
      </div>

      {/* Releases Carousel */}
      <div ref={trackRef} className="flex gap-8 overflow-x-auto snap-x snap-mandatory pb-4 -mx-6 px-6 md:mx-0 md:px-0 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" data-id="element-59">
        {RELEASES.map((release, i) => <motion.a key={release.title} data-card href={release.url} target="_blank" rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1,
        duration: 0.6
      }} className="group block shrink-0 w-[75vw] sm:w-72 lg:w-80 snap-start focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-4 focus-visible:ring-offset-brand-black" data-id="element-60">
            <div className="relative aspect-square overflow-hidden bg-brand-surface mb-4" data-id="element-61">
              {release.image && <img src={release.image} alt={release.title} draggable={false} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-62" />}
            </div>
            <div className="flex justify-between items-start" data-id="element-63">
              <div data-id="element-64">
                <h4 className="font-display text-2xl text-brand-white uppercase tracking-wider mb-1" data-id="element-65">
                  {release.title}
                </h4>
                <p className="text-brand-muted text-sm uppercase tracking-widest" data-id="element-66">
                  {release.type}
                </p>
              </div>
            </div>
          </motion.a>)}
      </div>
    </section>;
}